'use client';

import clsx from 'clsx';
import DallasText from '@ui/Dallas/Text/DallasText';
import { FrontendLoad } from '@trucksmarter/shared';
import { DallasTableDataCell } from '@ui/Dallas/Table/DallasTable';
import { toRelativeFromISO } from '~/utils/datetime';
import { useViewedLoadIds } from '../LoadBoardViewedLoadIdsProvider';
import { useIncomingLoadIds } from '../LoadBoardIncomingLoadIdsByQueryStringProvider';
import { useLoadsSearchQueryString } from '../LoadsSearchRequestProvider';

import styles from './AgeCell.module.scss';

type Props = {
  className?: string;
  load: FrontendLoad;
};

export default function AgeCell({ className, load }: Props) {
  const queryString = useLoadsSearchQueryString();
  const viewedLoadIds = useViewedLoadIds();
  const incomingLoadIds = useIncomingLoadIds(queryString);
  const isNotViewed = viewedLoadIds?.has(load.id) === false;
  const isIncoming = incomingLoadIds?.has(load.id) === true;

  return (
    <DallasTableDataCell className={clsx(className, styles.root)}>
      {load.available && isNotViewed && (
        <div
          className={clsx(
            styles.badge,
            isIncoming ? styles.incoming : styles.notViewed,
          )}
        />
      )}
      <DallasText variant="captionL">
        {toRelativeFromISO(load.createdAt, { maxDays: 2 })}
      </DallasText>
    </DallasTableDataCell>
  );
}
